export const newsletterAdministrationDe = {
  admin: {
    title: 'Newsletter-Administration',
    description:
      'Diese Einstellungen steuern technische Schutzmechanismen. Rechtstexte, Rechtsgrundlagen, Fristen und Tracking müssen vor dem Produktivbetrieb extern geprüft werden.',
    loadFailed: 'Newsletter-Einstellungen konnten nicht geladen werden.',
    openSection: 'Bereich öffnen',
    noProvider: 'Kein Standardprovider',
    messages: {
      invalid: 'Bitte prüfen Sie die markierten Einstellungen.',
      saved: 'Newsletter-Einstellungen wurden gespeichert.',
      failed: 'Newsletter-Einstellungen konnten nicht gespeichert werden.',
      brandSaved: 'Unternehmens- und Absenderangaben wurden gespeichert.',
    },
    general: {
      title: 'Einwilligung, Sprache und Aufbewahrung',
      description:
        'Fristen sind mandantenbezogen und müssen zum dokumentierten Lösch- und Aufbewahrungskonzept passen.',
    },
    delivery: {
      title: 'Versandkontrollen und Limits',
      description:
        'Testmodus, Versandsperre und Vier-Augen-Prinzip gelten ausschließlich für Marketingkommunikation.',
    },
    fields: {
      defaultLocale: 'Standardsprache',
      doubleOptInValidityHours: 'DOI-Gültigkeit in Stunden',
      pendingRequestRetentionDays: 'Aufbewahrung offener Anfragen in Tagen',
      evidenceTechnicalDataRetentionDays: 'Technische Nachweisdaten in Tagen',
      preferenceTokenValidityDays: 'Preference-Token-Gültigkeit in Tagen',
      fourEyesRequired: 'Vier-Augen-Prinzip',
      marketingSendingBlocked: 'Alle Marketingversände sperren',
      marketingTestMode: 'Sicherer Testmodus',
      defaultTimezone: 'Standard-Zeitzone',
      deliveryBatchSize: 'Batchgröße',
      tenantRateLimitPerMinute: 'Mandantenlimit pro Minute',
      providerRateLimitPerMinute: 'Providerlimit pro Minute',
      deliveryMaxAttempts: 'Maximale Versandversuche',
      retryBaseMinutes: 'Basisabstand für Wiederholungen in Minuten',
      estimatedCostPerThousand: 'Geschätzte Kosten je 1.000 E-Mails',
      defaultProvider: 'Standardprovider',
      operationalRiskAcknowledged:
        'Ich habe Auswirkungen, Limits, Testmodus und produktive Versandsperre bewusst geprüft.',
    },
    brandFields: {
      name: 'Markenname',
      senderCompanyName: 'Absendendes Unternehmen',
      senderName: 'Absendername',
      replyTo: 'Reply-To',
      contactEmail: 'Kontakt-E-Mail',
      postalAddress: 'Ladungsfähige beziehungsweise erforderliche Anschrift',
      companyRegistration: 'Register- und Unternehmensangaben',
      imprintUrl: 'Impressumslink',
      privacyUrl: 'Datenschutzlink',
      isActive: 'Marke aktiv',
    },
    status: {
      publicForms: 'Öffentliche Anmeldung',
      publicFormsDescription: 'Rechtstexte, Themen und öffentliche Formulare verwalten.',
      existingCustomer: 'Bestandskunden-Ausnahme',
      existingCustomerDescription: 'Voraussetzungen und unabhängige Freigaben prüfen.',
      tracking: 'Individuelles Tracking',
      trackingDescription: 'Getrennte Freigaben und Tracking-Einwilligungen verwalten.',
      provider: 'Versandprovider',
      providerDescription: 'Provider, Marketingdomain und Webhooks konfigurieren.',
      enabled: 'Aktiv',
      disabled: 'Deaktiviert',
    },
    brands: {
      title: 'Unternehmens- und Absenderangaben',
      description:
        'Pflichtangaben werden serverseitig in jeden Marketing-Footer eingefügt und vor der Freigabe geprüft.',
      empty: 'Noch keine Marke vorhanden. Legen Sie zuerst eine Marke in der Übersicht an.',
    },
  },
  profile: {
    tab: 'Newsletter',
    title: 'Newsletterstatus und Nachweise',
    description:
      'Die Ansicht zeigt verknüpfte Kunden- und Kontaktadressen. Eine Aktivierung ist hier nicht möglich; eine neue Anmeldung erfordert Double-Opt-in oder einen besonders dokumentierten Nachweis.',
    loadFailed: 'Newsletterprofil konnte nicht geladen werden.',
    empty: 'Für diesen Geschäftspartner ist noch keine Newsletter-Identität vorhanden.',
    requestDoi: 'Neue DOI-Anfrage senden',
    exportReady: 'Der strukturierte Export wurde erstellt.',
    exportFailed: 'Der Export konnte nicht erstellt werden.',
    identity: {
      CUSTOMER: 'Kundenadresse',
      CONTACT: 'Kontaktadresse',
      PORTAL_USER: 'Portalbenutzer',
      INTERNAL_USER: 'Interner Benutzer',
      PARTNERLESS: 'Freier Empfänger',
    },
    doiStatus: 'Double-Opt-in',
    doiPending: 'Noch nicht bestätigt',
    doiConfirmed: 'Bestätigt',
    trackingConsent: 'Separate Tracking-Einwilligung',
    granted: 'Erteilt',
    notGranted: 'Nicht erteilt oder widerrufen',
    topics: 'Abonnierte Themen',
    noTopics: 'Keine Themenzuordnung.',
    exportEvidence: 'Einwilligungsnachweis exportieren',
    exportPrivacy: 'Datenschutzexport erstellen',
    campaigns: 'Kampagnen- und Versandhistorie',
    noCampaigns: 'Noch kein dokumentierter Kampagnenversand.',
    deliveryStatus: {
      PENDING: 'Ausstehend',
      QUEUED: 'Eingereiht',
      PROCESSING: 'In Verarbeitung',
      ACCEPTED: 'Vom Provider angenommen',
      TEMPORARY_FAILED: 'Temporär fehlgeschlagen',
      PERMANENT_FAILED: 'Dauerhaft fehlgeschlagen',
      SKIPPED: 'Übersprungen',
      CANCELLED: 'Abgebrochen',
      UNKNOWN_OUTCOME: 'Ausgang unbekannt',
    },
    outcome: {
      UNKNOWN: 'Ausgang unbekannt',
      DELIVERED: 'Vom Provider als zugestellt gemeldet',
      SOFT_BOUNCED: 'Soft Bounce',
      HARD_BOUNCED: 'Hard Bounce',
      COMPLAINED: 'Spam-Beschwerde',
    },
    feedback: 'Bounces und Beschwerden',
    providerEvent: {
      DELIVERED: 'Provider meldet Zustellung',
      SOFT_BOUNCE: 'Soft Bounce',
      HARD_BOUNCE: 'Hard Bounce',
      COMPLAINT: 'Spam-Beschwerde',
    },
    suppressions: 'Sperren und Abmeldungen',
    noDetail: 'Kein zusätzlicher Grund gespeichert.',
    consentHistory: 'Vollständige Einwilligungshistorie',
    noHistory: 'Noch kein Einwilligungsereignis vorhanden.',
    consentVersion: 'Einwilligungstext-Version und Hash',
    privacyVersion: 'Datenschutzhinweis-Version und Hash',
  },
} as const;

export const newsletterAdministrationEn = {
  admin: {
    title: 'Newsletter administration',
    description:
      'These settings control technical safeguards. Legal copy, legal bases, retention periods and tracking must be reviewed externally before production use.',
    loadFailed: 'Newsletter settings could not be loaded.',
    openSection: 'Open section',
    noProvider: 'No default provider',
    messages: {
      invalid: 'Please review the highlighted settings.',
      saved: 'Newsletter settings were saved.',
      failed: 'Newsletter settings could not be saved.',
      brandSaved: 'Company and sender details were saved.',
    },
    general: {
      title: 'Consent, language and retention',
      description:
        'Periods apply per tenant and must match the documented deletion and retention policy.',
    },
    delivery: {
      title: 'Delivery controls and limits',
      description:
        'Test mode, delivery block and four-eyes review apply only to marketing communication.',
    },
    fields: {
      defaultLocale: 'Default language',
      doubleOptInValidityHours: 'DOI validity in hours',
      pendingRequestRetentionDays: 'Pending-request retention in days',
      evidenceTechnicalDataRetentionDays: 'Technical evidence retention in days',
      preferenceTokenValidityDays: 'Preference-token validity in days',
      fourEyesRequired: 'Four-eyes review',
      marketingSendingBlocked: 'Block all marketing delivery',
      marketingTestMode: 'Safe test mode',
      defaultTimezone: 'Default time zone',
      deliveryBatchSize: 'Batch size',
      tenantRateLimitPerMinute: 'Tenant limit per minute',
      providerRateLimitPerMinute: 'Provider limit per minute',
      deliveryMaxAttempts: 'Maximum delivery attempts',
      retryBaseMinutes: 'Base retry interval in minutes',
      estimatedCostPerThousand: 'Estimated cost per 1,000 emails',
      defaultProvider: 'Default provider',
      operationalRiskAcknowledged:
        'I deliberately reviewed the impact, limits, test mode and production delivery block.',
    },
    brandFields: {
      name: 'Brand name',
      senderCompanyName: 'Sending company',
      senderName: 'Sender name',
      replyTo: 'Reply-To',
      contactEmail: 'Contact email',
      postalAddress: 'Serviceable or otherwise required address',
      companyRegistration: 'Registration and company details',
      imprintUrl: 'Legal-notice link',
      privacyUrl: 'Privacy link',
      isActive: 'Brand active',
    },
    status: {
      publicForms: 'Public subscription',
      publicFormsDescription: 'Manage legal copy, topics and public forms.',
      existingCustomer: 'Existing-customer exception',
      existingCustomerDescription: 'Review prerequisites and independent approvals.',
      tracking: 'Individual tracking',
      trackingDescription: 'Manage separate approvals and tracking consent.',
      provider: 'Delivery provider',
      providerDescription: 'Configure provider, marketing domain and webhooks.',
      enabled: 'Enabled',
      disabled: 'Disabled',
    },
    brands: {
      title: 'Company and sender details',
      description:
        'Mandatory details are inserted server-side into every marketing footer and checked before approval.',
      empty: 'No brand exists yet. Create a brand from the overview first.',
    },
  },
  profile: {
    tab: 'Newsletter',
    title: 'Newsletter status and evidence',
    description:
      'This view shows linked customer and contact addresses. Activation is not available here; a new subscription requires double opt-in or specially documented evidence.',
    loadFailed: 'The newsletter profile could not be loaded.',
    empty: 'No newsletter identity exists for this business partner yet.',
    requestDoi: 'Send a new DOI request',
    exportReady: 'The structured export was created.',
    exportFailed: 'The export could not be created.',
    identity: {
      CUSTOMER: 'Customer address',
      CONTACT: 'Contact address',
      PORTAL_USER: 'Portal user',
      INTERNAL_USER: 'Internal user',
      PARTNERLESS: 'Independent recipient',
    },
    doiStatus: 'Double opt-in',
    doiPending: 'Not confirmed yet',
    doiConfirmed: 'Confirmed',
    trackingConsent: 'Separate tracking consent',
    granted: 'Granted',
    notGranted: 'Not granted or withdrawn',
    topics: 'Subscribed topics',
    noTopics: 'No topic assignment.',
    exportEvidence: 'Export consent evidence',
    exportPrivacy: 'Create privacy export',
    campaigns: 'Campaign and delivery history',
    noCampaigns: 'No documented campaign delivery yet.',
    deliveryStatus: {
      PENDING: 'Pending',
      QUEUED: 'Queued',
      PROCESSING: 'Processing',
      ACCEPTED: 'Accepted by provider',
      TEMPORARY_FAILED: 'Temporarily failed',
      PERMANENT_FAILED: 'Permanently failed',
      SKIPPED: 'Skipped',
      CANCELLED: 'Cancelled',
      UNKNOWN_OUTCOME: 'Outcome unknown',
    },
    outcome: {
      UNKNOWN: 'Outcome unknown',
      DELIVERED: 'Reported delivered by provider',
      SOFT_BOUNCED: 'Soft bounce',
      HARD_BOUNCED: 'Hard bounce',
      COMPLAINED: 'Spam complaint',
    },
    feedback: 'Bounces and complaints',
    providerEvent: {
      DELIVERED: 'Provider reports delivery',
      SOFT_BOUNCE: 'Soft bounce',
      HARD_BOUNCE: 'Hard bounce',
      COMPLAINT: 'Spam complaint',
    },
    suppressions: 'Suppressions and unsubscribes',
    noDetail: 'No additional reason stored.',
    consentHistory: 'Complete consent history',
    noHistory: 'No consent event exists yet.',
    consentVersion: 'Consent-copy version and hash',
    privacyVersion: 'Privacy-notice version and hash',
  },
} as const;

export const newsletterAdministrationTr = {
  admin: {
    title: 'Bülten yönetimi',
    description:
      'Bu ayarlar teknik korumaları yönetir. Hukuki metinler, dayanaklar, saklama süreleri ve takip üretimden önce dış uzmanlarca incelenmelidir.',
    loadFailed: 'Bülten ayarları yüklenemedi.',
    openSection: 'Bölümü aç',
    noProvider: 'Varsayılan sağlayıcı yok',
    messages: {
      invalid: 'Lütfen işaretli ayarları kontrol edin.',
      saved: 'Bülten ayarları kaydedildi.',
      failed: 'Bülten ayarları kaydedilemedi.',
      brandSaved: 'Şirket ve gönderen bilgileri kaydedildi.',
    },
    general: {
      title: 'Rıza, dil ve saklama',
      description:
        'Süreler kiracı bazındadır ve belgelenmiş silme-saklama planıyla uyumlu olmalıdır.',
    },
    delivery: {
      title: 'Gönderim kontrolleri ve sınırlar',
      description:
        'Test modu, gönderim engeli ve dört göz ilkesi yalnız pazarlama iletişimine uygulanır.',
    },
    fields: {
      defaultLocale: 'Varsayılan dil',
      doubleOptInValidityHours: 'DOI geçerliliği (saat)',
      pendingRequestRetentionDays: 'Bekleyen istek saklama süresi (gün)',
      evidenceTechnicalDataRetentionDays: 'Teknik kanıt saklama süresi (gün)',
      preferenceTokenValidityDays: 'Tercih belirteci geçerliliği (gün)',
      fourEyesRequired: 'Dört göz ilkesi',
      marketingSendingBlocked: 'Tüm pazarlama gönderimlerini engelle',
      marketingTestMode: 'Güvenli test modu',
      defaultTimezone: 'Varsayılan saat dilimi',
      deliveryBatchSize: 'Parti boyutu',
      tenantRateLimitPerMinute: 'Dakika başına kiracı sınırı',
      providerRateLimitPerMinute: 'Dakika başına sağlayıcı sınırı',
      deliveryMaxAttempts: 'Azami gönderim denemesi',
      retryBaseMinutes: 'Yeniden deneme temel aralığı (dakika)',
      estimatedCostPerThousand: '1.000 e-posta için tahmini maliyet',
      defaultProvider: 'Varsayılan sağlayıcı',
      operationalRiskAcknowledged:
        'Etkileri, sınırları, test modunu ve üretim gönderim engelini bilinçli olarak inceledim.',
    },
    brandFields: {
      name: 'Marka adı',
      senderCompanyName: 'Gönderen şirket',
      senderName: 'Gönderen adı',
      replyTo: 'Yanıt adresi',
      contactEmail: 'İletişim e-postası',
      postalAddress: 'Tebligata elverişli veya gerekli adres',
      companyRegistration: 'Sicil ve şirket bilgileri',
      imprintUrl: 'Yasal bildirim bağlantısı',
      privacyUrl: 'Gizlilik bağlantısı',
      isActive: 'Marka etkin',
    },
    status: {
      publicForms: 'Herkese açık abonelik',
      publicFormsDescription: 'Hukuki metinleri, konuları ve formları yönetin.',
      existingCustomer: 'Mevcut müşteri istisnası',
      existingCustomerDescription: 'Koşulları ve bağımsız onayları inceleyin.',
      tracking: 'Bireysel takip',
      trackingDescription: 'Ayrı onayları ve takip rızasını yönetin.',
      provider: 'Gönderim sağlayıcısı',
      providerDescription: 'Sağlayıcıyı, pazarlama alan adını ve webhookları yapılandırın.',
      enabled: 'Etkin',
      disabled: 'Devre dışı',
    },
    brands: {
      title: 'Şirket ve gönderen bilgileri',
      description:
        'Zorunlu bilgiler sunucuda her pazarlama altbilgisine eklenir ve onaydan önce denetlenir.',
      empty: 'Henüz marka yok. Önce genel bakıştan bir marka oluşturun.',
    },
  },
  profile: {
    tab: 'Bülten',
    title: 'Bülten durumu ve kanıtlar',
    description:
      'Bağlı müşteri ve kişi adreslerini gösterir. Buradan etkinleştirme yapılamaz; yeni abonelik DOI veya özel belgelenmiş kanıt gerektirir.',
    loadFailed: 'Bülten profili yüklenemedi.',
    empty: 'Bu iş ortağı için henüz bülten kimliği yok.',
    requestDoi: 'Yeni DOI isteği gönder',
    exportReady: 'Yapılandırılmış dışa aktarma oluşturuldu.',
    exportFailed: 'Dışa aktarma oluşturulamadı.',
    identity: {
      CUSTOMER: 'Müşteri adresi',
      CONTACT: 'Kişi adresi',
      PORTAL_USER: 'Portal kullanıcısı',
      INTERNAL_USER: 'Dahili kullanıcı',
      PARTNERLESS: 'Bağımsız alıcı',
    },
    doiStatus: 'Çift onay',
    doiPending: 'Henüz doğrulanmadı',
    doiConfirmed: 'Doğrulandı',
    trackingConsent: 'Ayrı takip rızası',
    granted: 'Verildi',
    notGranted: 'Verilmedi veya geri çekildi',
    topics: 'Abone olunan konular',
    noTopics: 'Konu ataması yok.',
    exportEvidence: 'Rıza kanıtını dışa aktar',
    exportPrivacy: 'Gizlilik dışa aktarımı oluştur',
    campaigns: 'Kampanya ve gönderim geçmişi',
    noCampaigns: 'Henüz belgelenmiş kampanya gönderimi yok.',
    deliveryStatus: {
      PENDING: 'Bekliyor',
      QUEUED: 'Kuyrukta',
      PROCESSING: 'İşleniyor',
      ACCEPTED: 'Sağlayıcı kabul etti',
      TEMPORARY_FAILED: 'Geçici hata',
      PERMANENT_FAILED: 'Kalıcı hata',
      SKIPPED: 'Atlandı',
      CANCELLED: 'İptal edildi',
      UNKNOWN_OUTCOME: 'Sonuç bilinmiyor',
    },
    outcome: {
      UNKNOWN: 'Sonuç bilinmiyor',
      DELIVERED: 'Sağlayıcı teslim edildi bildirdi',
      SOFT_BOUNCED: 'Geçici geri dönüş',
      HARD_BOUNCED: 'Kalıcı geri dönüş',
      COMPLAINED: 'Spam şikâyeti',
    },
    feedback: 'Geri dönüşler ve şikâyetler',
    providerEvent: {
      DELIVERED: 'Sağlayıcı teslimat bildirdi',
      SOFT_BOUNCE: 'Geçici geri dönüş',
      HARD_BOUNCE: 'Kalıcı geri dönüş',
      COMPLAINT: 'Spam şikâyeti',
    },
    suppressions: 'Engeller ve abonelikten çıkmalar',
    noDetail: 'Ek neden kaydedilmedi.',
    consentHistory: 'Eksiksiz rıza geçmişi',
    noHistory: 'Henüz rıza olayı yok.',
    consentVersion: 'Rıza metni sürümü ve özeti',
    privacyVersion: 'Gizlilik bildirimi sürümü ve özeti',
  },
} as const;

export const newsletterAdministrationFr = {
  admin: {
    title: 'Administration des newsletters',
    description:
      'Ces réglages pilotent les protections techniques. Textes juridiques, bases, durées et suivi doivent être vérifiés par des spécialistes avant la production.',
    loadFailed: 'Impossible de charger les réglages newsletter.',
    openSection: 'Ouvrir la section',
    noProvider: 'Aucun fournisseur par défaut',
    messages: {
      invalid: 'Vérifiez les réglages signalés.',
      saved: 'Réglages newsletter enregistrés.',
      failed: 'Impossible d’enregistrer les réglages.',
      brandSaved: 'Informations société et expéditeur enregistrées.',
    },
    general: {
      title: 'Consentement, langue et conservation',
      description:
        'Les durées sont propres au tenant et doivent correspondre au plan documenté de suppression et de conservation.',
    },
    delivery: {
      title: 'Contrôles et limites d’envoi',
      description:
        'Mode test, blocage et principe des quatre yeux concernent uniquement la communication marketing.',
    },
    fields: {
      defaultLocale: 'Langue par défaut',
      doubleOptInValidityHours: 'Validité DOI en heures',
      pendingRequestRetentionDays: 'Conservation des demandes en attente en jours',
      evidenceTechnicalDataRetentionDays: 'Conservation des preuves techniques en jours',
      preferenceTokenValidityDays: 'Validité du jeton de préférences en jours',
      fourEyesRequired: 'Principe des quatre yeux',
      marketingSendingBlocked: 'Bloquer tous les envois marketing',
      marketingTestMode: 'Mode test sécurisé',
      defaultTimezone: 'Fuseau horaire par défaut',
      deliveryBatchSize: 'Taille de lot',
      tenantRateLimitPerMinute: 'Limite tenant par minute',
      providerRateLimitPerMinute: 'Limite fournisseur par minute',
      deliveryMaxAttempts: 'Nombre maximal de tentatives',
      retryBaseMinutes: 'Intervalle de reprise en minutes',
      estimatedCostPerThousand: 'Coût estimé pour 1 000 e-mails',
      defaultProvider: 'Fournisseur par défaut',
      operationalRiskAcknowledged:
        'J’ai examiné consciemment les impacts, limites, le mode test et le blocage des envois de production.',
    },
    brandFields: {
      name: 'Nom de marque',
      senderCompanyName: 'Société expéditrice',
      senderName: 'Nom d’expéditeur',
      replyTo: 'Adresse de réponse',
      contactEmail: 'E-mail de contact',
      postalAddress: 'Adresse de signification ou adresse requise',
      companyRegistration: 'Immatriculation et mentions société',
      imprintUrl: 'Lien mentions légales',
      privacyUrl: 'Lien confidentialité',
      isActive: 'Marque active',
    },
    status: {
      publicForms: 'Inscription publique',
      publicFormsDescription: 'Gérer textes, thèmes et formulaires publics.',
      existingCustomer: 'Exception client existant',
      existingCustomerDescription: 'Vérifier conditions et validations indépendantes.',
      tracking: 'Suivi individuel',
      trackingDescription: 'Gérer validations séparées et consentement au suivi.',
      provider: 'Fournisseur d’envoi',
      providerDescription: 'Configurer fournisseur, domaine marketing et webhooks.',
      enabled: 'Activé',
      disabled: 'Désactivé',
    },
    brands: {
      title: 'Informations société et expéditeur',
      description:
        'Les mentions obligatoires sont insérées côté serveur dans chaque pied marketing et contrôlées avant validation.',
      empty: 'Aucune marque. Créez d’abord une marque dans la vue d’ensemble.',
    },
  },
  profile: {
    tab: 'Newsletter',
    title: 'Statut newsletter et preuves',
    description:
      'Affiche les adresses client et contact liées. Aucune activation n’est possible ici ; une nouvelle inscription exige un double opt-in ou une preuve spécialement documentée.',
    loadFailed: 'Impossible de charger le profil newsletter.',
    empty: 'Aucune identité newsletter pour ce partenaire.',
    requestDoi: 'Envoyer une nouvelle demande DOI',
    exportReady: 'Export structuré créé.',
    exportFailed: 'Impossible de créer l’export.',
    identity: {
      CUSTOMER: 'Adresse client',
      CONTACT: 'Adresse contact',
      PORTAL_USER: 'Utilisateur portail',
      INTERNAL_USER: 'Utilisateur interne',
      PARTNERLESS: 'Destinataire indépendant',
    },
    doiStatus: 'Double opt-in',
    doiPending: 'Pas encore confirmé',
    doiConfirmed: 'Confirmé',
    trackingConsent: 'Consentement séparé au suivi',
    granted: 'Accordé',
    notGranted: 'Non accordé ou retiré',
    topics: 'Thèmes abonnés',
    noTopics: 'Aucun thème.',
    exportEvidence: 'Exporter la preuve de consentement',
    exportPrivacy: 'Créer l’export confidentialité',
    campaigns: 'Historique campagnes et envois',
    noCampaigns: 'Aucun envoi documenté.',
    deliveryStatus: {
      PENDING: 'En attente',
      QUEUED: 'En file',
      PROCESSING: 'En traitement',
      ACCEPTED: 'Accepté par le fournisseur',
      TEMPORARY_FAILED: 'Échec temporaire',
      PERMANENT_FAILED: 'Échec permanent',
      SKIPPED: 'Ignoré',
      CANCELLED: 'Annulé',
      UNKNOWN_OUTCOME: 'Résultat inconnu',
    },
    outcome: {
      UNKNOWN: 'Résultat inconnu',
      DELIVERED: 'Signalé livré par le fournisseur',
      SOFT_BOUNCED: 'Rebond temporaire',
      HARD_BOUNCED: 'Rebond permanent',
      COMPLAINED: 'Plainte pour spam',
    },
    feedback: 'Rebonds et plaintes',
    providerEvent: {
      DELIVERED: 'Livraison signalée',
      SOFT_BOUNCE: 'Rebond temporaire',
      HARD_BOUNCE: 'Rebond permanent',
      COMPLAINT: 'Plainte pour spam',
    },
    suppressions: 'Exclusions et désabonnements',
    noDetail: 'Aucun motif complémentaire.',
    consentHistory: 'Historique complet des consentements',
    noHistory: 'Aucun événement de consentement.',
    consentVersion: 'Version et empreinte du consentement',
    privacyVersion: 'Version et empreinte de l’avis de confidentialité',
  },
} as const;

export const newsletterAdministrationEs = {
  admin: {
    title: 'Administración de boletines',
    description:
      'Estos ajustes controlan las salvaguardas técnicas. Textos legales, bases, plazos y seguimiento deben revisarse externamente antes de producción.',
    loadFailed: 'No se pudieron cargar los ajustes.',
    openSection: 'Abrir sección',
    noProvider: 'Sin proveedor predeterminado',
    messages: {
      invalid: 'Revise los ajustes señalados.',
      saved: 'Ajustes guardados.',
      failed: 'No se pudieron guardar los ajustes.',
      brandSaved: 'Datos de empresa y remitente guardados.',
    },
    general: {
      title: 'Consentimiento, idioma y conservación',
      description:
        'Los plazos son por tenant y deben coincidir con el plan documentado de borrado y conservación.',
    },
    delivery: {
      title: 'Controles y límites de envío',
      description:
        'El modo de prueba, el bloqueo y el principio de cuatro ojos solo se aplican a comunicaciones comerciales.',
    },
    fields: {
      defaultLocale: 'Idioma predeterminado',
      doubleOptInValidityHours: 'Validez DOI en horas',
      pendingRequestRetentionDays: 'Conservación de solicitudes pendientes en días',
      evidenceTechnicalDataRetentionDays: 'Conservación de pruebas técnicas en días',
      preferenceTokenValidityDays: 'Validez del token de preferencias en días',
      fourEyesRequired: 'Principio de cuatro ojos',
      marketingSendingBlocked: 'Bloquear todos los envíos comerciales',
      marketingTestMode: 'Modo de prueba seguro',
      defaultTimezone: 'Zona horaria predeterminada',
      deliveryBatchSize: 'Tamaño del lote',
      tenantRateLimitPerMinute: 'Límite del tenant por minuto',
      providerRateLimitPerMinute: 'Límite del proveedor por minuto',
      deliveryMaxAttempts: 'Máximo de intentos',
      retryBaseMinutes: 'Intervalo base de reintento en minutos',
      estimatedCostPerThousand: 'Coste estimado por 1.000 correos',
      defaultProvider: 'Proveedor predeterminado',
      operationalRiskAcknowledged:
        'He revisado conscientemente los efectos, límites, el modo de prueba y el bloqueo de producción.',
    },
    brandFields: {
      name: 'Nombre de marca',
      senderCompanyName: 'Empresa remitente',
      senderName: 'Nombre del remitente',
      replyTo: 'Dirección de respuesta',
      contactEmail: 'Correo de contacto',
      postalAddress: 'Domicilio válido o dirección exigida',
      companyRegistration: 'Registro y datos empresariales',
      imprintUrl: 'Enlace de aviso legal',
      privacyUrl: 'Enlace de privacidad',
      isActive: 'Marca activa',
    },
    status: {
      publicForms: 'Suscripción pública',
      publicFormsDescription: 'Gestionar textos, temas y formularios públicos.',
      existingCustomer: 'Excepción de cliente existente',
      existingCustomerDescription: 'Revisar requisitos y aprobaciones independientes.',
      tracking: 'Seguimiento individual',
      trackingDescription: 'Gestionar aprobaciones separadas y consentimiento.',
      provider: 'Proveedor de envío',
      providerDescription: 'Configurar proveedor, dominio comercial y webhooks.',
      enabled: 'Activado',
      disabled: 'Desactivado',
    },
    brands: {
      title: 'Datos de empresa y remitente',
      description:
        'Los datos obligatorios se insertan en el servidor en cada pie comercial y se comprueban antes de aprobar.',
      empty: 'Aún no hay marca. Cree primero una desde el resumen.',
    },
  },
  profile: {
    tab: 'Boletín',
    title: 'Estado del boletín y pruebas',
    description:
      'Muestra direcciones vinculadas de clientes y contactos. Aquí no se puede activar; una nueva suscripción exige doble opt-in o prueba especialmente documentada.',
    loadFailed: 'No se pudo cargar el perfil.',
    empty: 'Aún no hay identidad de boletín para este socio.',
    requestDoi: 'Enviar nueva solicitud DOI',
    exportReady: 'Se creó la exportación estructurada.',
    exportFailed: 'No se pudo crear la exportación.',
    identity: {
      CUSTOMER: 'Dirección de cliente',
      CONTACT: 'Dirección de contacto',
      PORTAL_USER: 'Usuario del portal',
      INTERNAL_USER: 'Usuario interno',
      PARTNERLESS: 'Destinatario independiente',
    },
    doiStatus: 'Doble opt-in',
    doiPending: 'Aún sin confirmar',
    doiConfirmed: 'Confirmado',
    trackingConsent: 'Consentimiento separado de seguimiento',
    granted: 'Otorgado',
    notGranted: 'No otorgado o retirado',
    topics: 'Temas suscritos',
    noTopics: 'Sin temas.',
    exportEvidence: 'Exportar prueba de consentimiento',
    exportPrivacy: 'Crear exportación de privacidad',
    campaigns: 'Historial de campañas y envíos',
    noCampaigns: 'Sin envíos documentados.',
    deliveryStatus: {
      PENDING: 'Pendiente',
      QUEUED: 'En cola',
      PROCESSING: 'Procesando',
      ACCEPTED: 'Aceptado por el proveedor',
      TEMPORARY_FAILED: 'Fallo temporal',
      PERMANENT_FAILED: 'Fallo permanente',
      SKIPPED: 'Omitido',
      CANCELLED: 'Cancelado',
      UNKNOWN_OUTCOME: 'Resultado desconocido',
    },
    outcome: {
      UNKNOWN: 'Resultado desconocido',
      DELIVERED: 'Proveedor informa de entrega',
      SOFT_BOUNCED: 'Rebote temporal',
      HARD_BOUNCED: 'Rebote permanente',
      COMPLAINED: 'Queja de spam',
    },
    feedback: 'Rebotes y quejas',
    providerEvent: {
      DELIVERED: 'Entrega informada',
      SOFT_BOUNCE: 'Rebote temporal',
      HARD_BOUNCE: 'Rebote permanente',
      COMPLAINT: 'Queja de spam',
    },
    suppressions: 'Bloqueos y bajas',
    noDetail: 'Sin motivo adicional.',
    consentHistory: 'Historial completo de consentimiento',
    noHistory: 'Sin eventos de consentimiento.',
    consentVersion: 'Versión y hash del consentimiento',
    privacyVersion: 'Versión y hash del aviso de privacidad',
  },
} as const;

export const newsletterAdministrationRu = {
  admin: {
    title: 'Администрирование рассылок',
    description:
      'Эти настройки управляют техническими мерами защиты. Правовые тексты, основания, сроки и отслеживание должны пройти внешнюю проверку до эксплуатации.',
    loadFailed: 'Не удалось загрузить настройки.',
    openSection: 'Открыть раздел',
    noProvider: 'Нет провайдера по умолчанию',
    messages: {
      invalid: 'Проверьте отмеченные настройки.',
      saved: 'Настройки сохранены.',
      failed: 'Не удалось сохранить настройки.',
      brandSaved: 'Данные компании и отправителя сохранены.',
    },
    general: {
      title: 'Согласие, язык и хранение',
      description:
        'Сроки задаются для арендатора и должны соответствовать документированному плану удаления и хранения.',
    },
    delivery: {
      title: 'Контроль и лимиты отправки',
      description:
        'Тестовый режим, блокировка и принцип четырёх глаз применяются только к маркетинговым сообщениям.',
    },
    fields: {
      defaultLocale: 'Язык по умолчанию',
      doubleOptInValidityHours: 'Срок DOI в часах',
      pendingRequestRetentionDays: 'Хранение ожидающих запросов в днях',
      evidenceTechnicalDataRetentionDays: 'Хранение технических доказательств в днях',
      preferenceTokenValidityDays: 'Срок токена настроек в днях',
      fourEyesRequired: 'Принцип четырёх глаз',
      marketingSendingBlocked: 'Заблокировать все маркетинговые отправки',
      marketingTestMode: 'Безопасный тестовый режим',
      defaultTimezone: 'Часовой пояс по умолчанию',
      deliveryBatchSize: 'Размер пакета',
      tenantRateLimitPerMinute: 'Лимит арендатора в минуту',
      providerRateLimitPerMinute: 'Лимит провайдера в минуту',
      deliveryMaxAttempts: 'Максимум попыток',
      retryBaseMinutes: 'Базовый интервал повтора в минутах',
      estimatedCostPerThousand: 'Оценочная стоимость 1 000 писем',
      defaultProvider: 'Провайдер по умолчанию',
      operationalRiskAcknowledged:
        'Я осознанно проверил последствия, лимиты, тестовый режим и блокировку производственной отправки.',
    },
    brandFields: {
      name: 'Название бренда',
      senderCompanyName: 'Компания-отправитель',
      senderName: 'Имя отправителя',
      replyTo: 'Адрес для ответа',
      contactEmail: 'Контактный e-mail',
      postalAddress: 'Юридически значимый или обязательный адрес',
      companyRegistration: 'Регистрационные данные компании',
      imprintUrl: 'Ссылка на правовую информацию',
      privacyUrl: 'Ссылка на конфиденциальность',
      isActive: 'Бренд активен',
    },
    status: {
      publicForms: 'Публичная подписка',
      publicFormsDescription: 'Управление текстами, темами и формами.',
      existingCustomer: 'Исключение для клиентов',
      existingCustomerDescription: 'Проверка условий и независимых одобрений.',
      tracking: 'Индивидуальное отслеживание',
      trackingDescription: 'Управление отдельными одобрениями и согласием.',
      provider: 'Провайдер отправки',
      providerDescription: 'Настройка провайдера, домена и вебхуков.',
      enabled: 'Включено',
      disabled: 'Отключено',
    },
    brands: {
      title: 'Данные компании и отправителя',
      description:
        'Обязательные сведения сервер добавляет в каждый маркетинговый подвал и проверяет до одобрения.',
      empty: 'Брендов пока нет. Сначала создайте бренд в обзоре.',
    },
  },
  profile: {
    tab: 'Рассылки',
    title: 'Статус рассылки и доказательства',
    description:
      'Показаны связанные адреса клиента и контактов. Активация здесь невозможна: новая подписка требует DOI или специально документированного доказательства.',
    loadFailed: 'Не удалось загрузить профиль.',
    empty: 'Для партнёра ещё нет идентификатора рассылки.',
    requestDoi: 'Отправить новый DOI-запрос',
    exportReady: 'Структурированный экспорт создан.',
    exportFailed: 'Не удалось создать экспорт.',
    identity: {
      CUSTOMER: 'Адрес клиента',
      CONTACT: 'Адрес контакта',
      PORTAL_USER: 'Пользователь портала',
      INTERNAL_USER: 'Внутренний пользователь',
      PARTNERLESS: 'Независимый получатель',
    },
    doiStatus: 'Двойное подтверждение',
    doiPending: 'Ещё не подтверждено',
    doiConfirmed: 'Подтверждено',
    trackingConsent: 'Отдельное согласие на отслеживание',
    granted: 'Дано',
    notGranted: 'Не дано или отозвано',
    topics: 'Темы подписки',
    noTopics: 'Темы не назначены.',
    exportEvidence: 'Экспорт доказательства согласия',
    exportPrivacy: 'Создать экспорт данных',
    campaigns: 'История кампаний и отправки',
    noCampaigns: 'Документированных отправок нет.',
    deliveryStatus: {
      PENDING: 'Ожидает',
      QUEUED: 'В очереди',
      PROCESSING: 'Обрабатывается',
      ACCEPTED: 'Принято провайдером',
      TEMPORARY_FAILED: 'Временная ошибка',
      PERMANENT_FAILED: 'Постоянная ошибка',
      SKIPPED: 'Пропущено',
      CANCELLED: 'Отменено',
      UNKNOWN_OUTCOME: 'Результат неизвестен',
    },
    outcome: {
      UNKNOWN: 'Результат неизвестен',
      DELIVERED: 'Провайдер сообщил о доставке',
      SOFT_BOUNCED: 'Мягкий возврат',
      HARD_BOUNCED: 'Жёсткий возврат',
      COMPLAINED: 'Жалоба на спам',
    },
    feedback: 'Возвраты и жалобы',
    providerEvent: {
      DELIVERED: 'Доставка по данным провайдера',
      SOFT_BOUNCE: 'Мягкий возврат',
      HARD_BOUNCE: 'Жёсткий возврат',
      COMPLAINT: 'Жалоба на спам',
    },
    suppressions: 'Блокировки и отписки',
    noDetail: 'Дополнительная причина не сохранена.',
    consentHistory: 'Полная история согласия',
    noHistory: 'Событий согласия пока нет.',
    consentVersion: 'Версия и хеш текста согласия',
    privacyVersion: 'Версия и хеш уведомления о конфиденциальности',
  },
} as const;
